export var buttonReset = "\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n\n  font: inherit;\n  border: none;\n  background: transparent;\n\n  appearance: none;\n  cursor: pointer;\n";
//# sourceMappingURL=buttonReset.js.map